// Component: KillSwitchBanner.jsx
// Purpose: #133 — app-wide surface for the caller's OWN user-scope kill-switch (tripped by the
//          R57 cascade when a live entry fills unprotected). Renders NOTHING while inactive;
//          when ACTIVE: one red band under the navbar (what + when, no raw ids) and a single
//          "Resume trading…" button that opens the shared ResumeTradingModal.
//          Deepak, live-val 2026-08-28: "this should be ideally something in the front end …
//          so we can live test it and manage it".

import React, { useState } from 'react';
import { Button } from '../ds';
import { useOwnKillSwitch, fmtIstTime } from '../../hooks/trading/useOwnKillSwitch';
import ResumeTradingModal from './ResumeTradingModal';

//--> "bracket_attach_cascade_exhausted:order=<uuid>:sii=<sii>" → a short human label; the raw
//    reason stays available in the modal.
const summarizeTrip = (reason) => {
  if (!reason) return 'no reason recorded';
  const head = String(reason).split(':')[0];
  const labels = {
    bracket_attach_cascade_exhausted: 'a live entry filled without SL/TP protection',
  };
  return labels[head] || head.replace(/_/g, ' ');
};

export default function KillSwitchBanner() {
  /*>>> State <<<*/
  const { active, trip, degraded, busy, error, setError, resume } = useOwnKillSwitch();
  const [open, setOpen] = useState(false);

  if (!active) return null;

  return (
    <>
      <div
        role="alert"
        data-testid="kill-switch-banner"
        style={{
          background: '#7f1d1d',
          color: '#fff',
          padding: '10px 16px',
          display: 'flex',
          alignItems: 'center',
          gap: '16px',
          borderBottom: '2px solid #fca5a5',
        }}
      >
        <div style={{ flex: '1 1 auto', minWidth: 0 }}>
          <strong>⛔ Trading halted for your account</strong>
          <span style={{ opacity: 0.9 }}>
            {' — '}new live entries are refused.
            {trip ? ` Tripped ${fmtIstTime(trip.timestamp)} IST: ${summarizeTrip(trip.reason)}.` : ''}
            {degraded ? ' (state read degraded — showing last known state)' : ''}
          </span>
        </div>
        <Button variant="secondary" size="sm" onClick={() => setOpen(true)} disabled={busy}>
          Resume trading…
        </Button>
      </div>
      <ResumeTradingModal
        open={open}
        onClose={() => setOpen(false)}
        trip={trip}
        busy={busy}
        error={error}
        setError={setError}
        resume={resume}
      />
    </>
  );
}
